<template>
  <div>
    <van-nav-bar
      title="纪念馆提示"
      left-arrow
      fixed
      :z-index="99"
      @click-left="onClickLeft"
      :border="false"
    />
    <br />
    <br />
    <p class="contain">
        此纪念馆为非公开纪念馆，如果自身为馆主可以进行登录即可畅通访问！(注：如想让任何人访问，可以向客服申请为公开馆)<br />
        <p style="color: black;" >
          全国服务热线电话<a href="tel:4009630096" style="color:green" >400-963-0096</a>工作日：9:00-18:00（周一至周五）
        </p>

    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {


    };
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
  },
  created() {},
};
</script>

<style>
    .contain{
        padding: 5px;
        color: red;
    }

</style>
